import React from 'react';
import styled from '@emotion/styled';

const WindowStyles = styled.div`
display: flex;
align-items: center;
background: #569CD6;
height: 30px;
width: 100%;


> div {
    width: 15px;
    height: 14px;
    border-radius: 50%;
    margin-left: 10px;
}

.red {
    background: #EE6C60;
}

.yellow {
    background: #F7C250;
}

.green {
    background: #65CC57;
}
`;

const Window = () => {
    return (
        <WindowStyles>
            <div className="red" />
            <div className="yellow" />
            <div className="green" />
        </WindowStyles>
    );
};

export default Window;